import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import useStyles from "../../settings/styles";

const states = {
  activo: "green",
  suspendido: "yellow",
  inactivo: "gray",
  borrado: "red",
};

export default function MembershipTable({ data, currentPage, totalPages, onPreviousPage, onNextPage, onClick, accumulatedItems, totalItems, isSearch }) {
  const classes = useStyles();

  if (data == null || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root} >
            <TableCell size='small' >NOMBRE</TableCell>
            <TableCell size='small' padding='none' >COSTO</TableCell>
            <TableCell size='small' padding='none' >TIPO DE MEMBRECÍA</TableCell>
            <TableCell size='small' padding='none' >ESTATUS</TableCell>
            {/*{keys.map(key => (
            <TableCell key={key}>{key}</TableCell>
          ))}*/}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ id, membershipName, cost, membershipType, status }) => (
            <TableRow key={id} className={classes.rowTableHover}
              onClick={onClick(id)}
            >
              <TableCell size='small' className={classes.tableTextStyle} >{membershipName}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle} >{"$ " + cost.toFixed(2)}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle} >{membershipType}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle} >
                <Chip label={status} classes={{ root: classes[states[status.toLowerCase()]] }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isSearch != null && isSearch ? (
        <></>
      ) : (
        <>
          <div className={classes.footerTableMembership}>
            <div className={classes.footerTableFirstDiv}>
              <p className={classes.footerText}>TOTAL: {accumulatedItems} DE {totalItems}</p>
            </div>

            <div className={classes.footerTableSecondDiv}>
              <p className={classes.footerText}>PÁGINA: {currentPage} DE {totalPages}</p>
              <div className={currentPage <= 1 ? classes.buttonPageDisableArrowDiv :
                classes.buttonPageEnableArrowDiv}>
                <Icons.ArrowBackIos className={currentPage <= 1 ?
                  classes.buttonPageDisableArrow : classes.buttonPageEnableArrow}
                  onClick={currentPage <= 1 ? null : onPreviousPage}
                />
              </div>
              <div className={classes.spaceBetweenButtons}></div>
              <div className={currentPage == totalPages ? classes.buttonPageDisableArrowDiv :
                classes.buttonPageEnableArrowDiv}>
                <Icons.ArrowForwardIos className={currentPage == totalPages ?
                  classes.buttonPageDisableArrowForward : classes.buttonPageEnableArrowForward}
                  onClick={currentPage == totalPages ? null : onNextPage}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
